
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[orderMethod]/[venueXRefID]/[orderXRefID]",
      function () {
        return require("private-next-pages/[orderMethod]/[venueXRefID]/[orderXRefID].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[orderMethod]/[venueXRefID]/[orderXRefID]"])
      });
    }
  